const dedicatedDietList = {
    getlist: 'question/getlist',
    add: 'question/add',
    update: 'question/update',
    remove: 'question/remove',
    get: 'question/get-by-admin',
    getall: 'question/getall',
}
export default dedicatedDietList
